module.exports = __webpack_public_path__ + "static/media/img10.3480d982.jpg";